module.exports = __webpack_public_path__ + "static/media/operation2ndchance.582a4999.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/operation2ndchance.png
// module id = 96
// module chunks = 0